export { default } from './Pressable';
//# sourceMappingURL=index.js.map